const REGISTER_ERROR_MESSAGES = Object.freeze({
  'auth/email-already-in-use': 'Този имейл вече е регистриран.',
  'auth/invalid-email': 'Невалиден имейл адрес.',
  'auth/weak-password': 'Паролата е твърде слаба. Моля, използвайте по-силна парола.',
});

const LOGIN_ERROR_MESSAGES = Object.freeze({
  'auth/user-not-found': 'Потребителят не е намерен. Моля, проверете вашия имейл.',
  'auth/wrong-password': 'Грешна парола. Моля, опитайте отново.',
  'auth/invalid-email': 'Невалиден имейл адрес.',
  'auth/user-disabled': 'Този акаунт е деактивиран.',
  'auth/too-many-requests': 'Твърде много неуспешни опити. Моля, опитайте по-късно.',
});

const RESET_PASSWORD_ERROR_MESSAGES = Object.freeze({
  'auth/user-not-found': 'Потребител с този имейл не е намерен.',
  'auth/invalid-email': 'Невалиден имейл адрес.',
});

const getErrorCode = (error) => (error && typeof error === 'object' ? error.code : undefined);

const getErrorMessage = (error) =>
  error && typeof error === 'object' && typeof error.message === 'string'
    ? error.message
    : '';

export const toRegisterErrorMessage = (error) =>
  REGISTER_ERROR_MESSAGES[getErrorCode(error)] ||
  'Възникна грешка при регистрацията. Моля, опитайте отново.';

export const toLoginErrorMessage = (error) =>
  LOGIN_ERROR_MESSAGES[getErrorCode(error)] ||
  getErrorMessage(error) ||
  'Възникна грешка при влизане. Моля, опитайте отново.';

export const toResetPasswordErrorMessage = (error) =>
  RESET_PASSWORD_ERROR_MESSAGES[getErrorCode(error)] ||
  'Възникна грешка при изпращането на имейл за възстановяване. Моля, опитайте отново.';

